import cn from 'classnames'
import React, { ComponentPropsWithoutRef, FC, useContext } from 'react'

import styles from './Carousel.module.scss'
import { CarouselContext } from './utils'

type CarouselControlsProps = ComponentPropsWithoutRef<'div'> & {
  leftArrow: JSX.Element
  rightArrow: JSX.Element
}

const CarouselControls: FC<React.PropsWithChildren<CarouselControlsProps>> = ({
  leftArrow,
  rightArrow,
  className,
  ...props
}) => {
  const { moveToLeft, moveToRight, itemCount } = useContext(CarouselContext)

  if (itemCount > 1) {
    return (
      <div className={cn(styles.controls, className)} {...props}>
        {React.cloneElement(leftArrow, {
          onClick: moveToLeft,
        })}
        {React.cloneElement(rightArrow, {
          onClick: moveToRight,
        })}
      </div>
    )
  }

  return null
}

export default CarouselControls
